//dev
//export const SERVER_BASE_URL='https://dev-csr.darwynnfulfillment.com/prod-api';
//export const pk = 'pk_test_51JVLqPIDlKLz3sdBHjnNOattI3hIDYsOmBHGuZ5f4LVACLeDNubSg2xHjRQ5jt0zHIRDtOnaCOCy6yTN8CWHEmMM00erkfPv5n'

//测试
//export const SERVER_BASE_URL = 'https://test-csr.darwynnfulfillment.com/prod-api';
//export const pk = 'pk_test_51JVLqPIDlKLz3sdBHjnNOattI3hIDYsOmBHGuZ5f4LVACLeDNubSg2xHjRQ5jt0zHIRDtOnaCOCy6yTN8CWHEmMM00erkfPv5n'

//生产环境
// export const SERVER_BASE_URL = 'https://csr.darwynnfulfillment.com/prod-api';
// export const pk = ''..

export const CHECK_USERNAME = '/system/user/exist'
export const LOG_IN = '/auth/login'
export const LOG_OUT = '/auth/logout'
export const REGISTER = '/auth/register'
export const REGISTER_v2 = '/auth/register'
export const VERIFICATION_URL = '/code'
export const Refresh = '/auth/refresh'
export const IsAdmin_URL = '/member/userManage/check/auth'
export const Get_Routes = 'system/menu/getRouters'
export const Get_Email_Code_Sign_In =  'member/msg/getEmailCodeForLoginVerify'
export const Get_Sign_In_Email_Code_Verify =  'member/msg/emailVerifyForLoginVerify'
export const Get_Email_Code_Sign_Up = '/member/msg/getEmailCode'
export const Get_Email_Code_Forget_Password = '/member/msg/getForgetPasswordEmailCode'
export const Get_Email_Code_Verify = '/member/msg/registerEmailVerify'
export const Get_Multi_Address_List = '/member/multiAddress/list'
export const Add_Multi_Address = '/member/multiAddress/save'
export const Remove_Multi_Address = '/member/multiAddress/remove'
export const Modify_Multi_Address = '/member/multiAddress/modify'

export const Forget_Password_URL = '/member/password/forget'
export const Forget_Password_By_User = '/member/password/forgetByOwnerId'

export const Reset_Password = '/member/password/modify'
export const Get_User_Setting = '/member/userSetting/'
export const Edit_User_Setting = '/member/userSetting/modify'

export const Edit_User_Setting_Email = '/member/userSetting/modify/email'

export const File_Upload = '/file/upload'

export const File_Upload_Wholesale = '/file/uploadDoc'

export const Search_Products = '/inventory/sku/list'

export const Dict_Type ='/member/dictType/list'

export const Account_Manager_List = '/member/owner/getAccountManagerList'

export const Product_Detail = '/inventory/sku/info'

export const Search_Package = '/inventory/sku/packageId'

export const Sku_Safe_Batch_Import = 'inventory/sku/modify/safety/inv'

export const Check_Product_Sku = '/inventory/sku/checkUnique'

export const Create_Product = '/inventory/sku/save'

export const Edit_Product = '/inventory/sku/modify'


export const Remove_Product = '/inventory/sku/remove'

export const Download_Product_Template = '/inventory/batchOpr/template'

export const Product_Import = '/inventory/batchOpr/skuImport'

export const Product_Batch_Import = '/inventory/batchOpr/skuImportV2'

export const SKU_Mapping_Import = '/inventory/batchOpr/skuMappingImport'

export const Kit_Import = '/inventory/batchOpr/kitImport'

export const Product_sku = '/inventory/sku/skuSelect'

export const Batch_Search = '/inventory/inv/lot'

export const Product_Search = '/inventory/inv/product'

export const Search_Kit = '/inventory/kit/list'

export const Sku_Choice  = '/inventory/sku/sku/choice'

export const Create_Kit = '/inventory/kit/save'

export const Kit_Detail = '/inventory/kit/info'

export const Edit_Kit = '/inventory/kit/modify'

export const Remove_Kit = '/inventory/kit/remove'

export const Filter_Packaging = '/inventory/package/list'

export const Filter_Invalid_Packaging = '/inventory/package/list/error'

export const Export_Invalid_Packaging_List = '/inventory/package/exportInvalid'

export const Export_Packaging_List = '/inventory/package/export'

export const Package_Information = '/inventory/package/info'


export const Filter_Map ='/inventory/skuMap/list'

export const Add_Map = '/inventory/skuMap/save'

export const Edit_Map = '/inventory/skuMap/modify'


export const Map_Info = '/inventory/skuMap/info'

export const Create_Kitting = '/inventory/kitting/save'

export const Search_Kitting = '/inventory/kitting/list'

export const Export_Kitting = '/inventory/batchOpr/kittingExport'

export const Kitting_Detail = '/inventory/kitting/info'

export const Kitting_Submit = '/inventory/kitting/submit'

export const Kitting_Cancel = '/inventory/kitting/cancel'

export const Kitting_Edit = '/inventory/kitting/edit'
//customer

export const Filter_Customer = '/member/customer/list'

export const Change_Customer_Active = '/member/customer/change'

export const Create_Customer = '/member/customer/save'

export const Customer_Information = '/member/customer/info'

export const Check_Customer_Id = '/member/customer/checkCustomerId'

export const Edit_Customer = '/member/customer/modify'

export const Edit_Customer_Address = '/member/customer/address/modify'

export const Add_Customer_Address = '/member/customer/address/add'

export const Delete_Customer_Address = '/member/customer/address/remove'

export const Remove_Customer = '/member/customer/remove'

export const Import_Customer = '/member/customer/batchImport'
// inbounds
export const Filter_ASN = '/business/inbound/list'

export const Withdraw_ASN = '/business/order/inbound/withdraw'

export const Change_ASN_Status = '/business/inbound/change'

export const Change_ASN_Submit = '/business/inbound/submit'

export const Change_ASN_Submit_v2 = '/business/inbound/submit'

export const Change_ASN_Audit = '/business/inbound/audit'

export const Customer_Choice = '/member/customer/choice'

export const Create_ASN ='/business/inbound/save'

export const Create_ASN_v2 ='/business/inbound/save'

export const Save_Submit_Return_ASN = '/business/inbound/saveAndSubmit'

export const Save_Submit_Inbound_ASN = '/business/inbound/saveAndSubmit'

export const Save_Submit_Inbound_ASN_v2 = '/business/inbound/saveAndSubmit'

export const Edit_Submit_ASN = '/business/inbound/modifyAndSubmit'

export const Edit_Submit_ASN_v2 = '/business/inbound/modifyAndSubmit'

export const ASN_Information = '/business/inbound/info'

export const Inbound_Warehouse_list = 'business/inbound/warehouse/list'

export const Edit_ASN='/business/inbound/modify'

export const Edit_ASN_v2='/business/inbound/modify'

export const ASN_Import ='/business/batchOpr/inboundImport'

export const Cancel_ASN ='/business/inbound/asnExecute/cancel'

export const Cancel_ASN_v2 ='/business/inbound/asnExecute/cancel'

export const Submit_ASN_Batch = '/business/inbound/batch/submit'

export const Submit_ASN_Batch_v2 = '/business/inbound/batch/submit'

export const Cancel_ASN_Batch = '/business/inbound/batch/asnExecute/cancel'

export const Cancel_ASN_Batch_v2 = '/business/inbound/batch/asnExecute/cancel'

export const Check_Inbound_From_Order_No = '/business/inbound/fromOrderNo/unique'

export const Return_Get_Rate = '/openapi/quote/rating'

export const Return_Get_Label = '/openapi/label/submit'

export const Return_Cancel_Label = '/openapi/tracking/voidShipment'

export const Return_Label_Generate_Receive = '/business/inbound/generateReceive'

export const Return_Label_Get_Package = '/business/order/wholesale/getPackageInfo'

//outbounds

export const Filter_Wholesale = '/business/order/warehouse/list'

export const Filter_Ecommerce = '/business/order/ecshop/list'

export const Platform_List_Owner = '/business/order/ecommerce/platformCode/list'

export const Warehouse_List_Owner = '/business/order/warehouse'

export const Create_Warehouse_Outbound = '/business/order/warehouse/save'

export const Create_And_Save_Warehouse_Outbound = '/business/order/warehouse/save-and-submit'

export const Edit_And_Save_Warehouse_Outbound = '/business/order/warehouse/modify-and-submit'

export const Split_Warehouse_Outbound = '/business/order/wholesale/split'

export const Edit_Warehouse_Outbound = '/business/order/warehouse/modify'

export const Submit_Wholesale = '/business/order/warehouse/submit'

export const Warehouse_Check = '/business/order/warehouse/check'

export const Withdraw_Wholesale = '/business/order/wholesale/withdraw'

export const SendEmailForDutyInfo = '/business/order/warehouse/sendEmail'

export const Outbound_Stock_Check = '/business/order/order-line-inv/check'

export const Outbound_Stock_Qty = '/business/order/order-line-inv/qty'

export const Wholesale_Information = '/business/order/warehouse/info'

export const Outbounds_Import = '/business/batchOpr/wOrderImport'

export const Outbounds_Import_Address_Based = '/business/batchOpr/wOrderImportByCustomerInfo'

export const Change_Order_Status = '/business/order/warehouse/change'

export const Submit_Wholesale_Batch = 'business/order/wholesale/batch/change'

export const Cancel_Wholesale_Batch = 'business/order/wholesale/batch/cancel'

export const Ecommerce_Order_Status = '/business/order/ecshop/submit'

export const Ecommerce_Information = '/business/order/ecshop/info'

export const Cancel_outbound = '/business/order/soExecute/cancel'

export const Cancel_outbound_wholesale = '/business/order/wholesale/cancel'

export const Cancel_outbound_ecommerce = '/business/order/ecommerce/cancel'

export const Edit_outbound_ecommerce = '/business/order/ecshop/modify'

export const Edit_And_Submit_outbound_ecommerce = '/business/order/ecshop/modify-and-submit'

export const Create_outbound_ecommerce = '/business/order/ecshop/copy'

export const Ecommerce_Order_Copy = '/business/order/ecshop//OmsCopy'

export const Withdraw_Ecommerce = '/business/order/ecommerce/withdraw'

export const Release_Ecommerce = '/business/order/ecshop/inventory/release'

export const Release_Wholesale = '/business/order/warehouse/inventory/release'

export const Edit_temu_outbound_ecommerce = '/business/order/ecommerce/temu'

export const Area_Code = '/business/order/ocpAreaMap'

export const Edit_Ship_Status= '/business/order/warehouse/shipStatus/modify'

export const Check_Wholesale_From_Order_No = '/business/order/warehouse/fromOrderNo/unique'

// transfers
export const Filter_Transfers = '/business/transfer/list'

export const Transfers_Details = '/business/transfer/details'

export const Check_Transfer_From_Order_No = '/business/transfer/fromOrderNo/unique'

export const Transfers_Save = '/business/transfer/save'
export const Transfers_Modify = '/business/transfer/modify'
export const Transfers_Submit = '/business/transfer/submit'
export const Transfers_Upload = '/business/transfer/upload'
export const Transfers_Cancel = '/business/transfer/cancel'

//reports
//date
export const Date_Search= '/report/inventory/date'
export const Export_Date='/report/export/dateInventory'

//aging
export const Aging_Search= '/report/inventory/agingInventory'
export const Export_Aging='/report/export/agingInventory'

//sku
export const Sku_Search = '/report/inventory/skuInventory'
export const Export_Sku = '/report/export/skuInventory'

//batch
export const Batch_Inv_Search = '/report/inventory/batchInventory'
export const Export_Batch='/report/export/batchInventory'

//expire date
export const Expire_Inv_Search = '/report/inventory/expireInventory'

export const Export_Expire = '/report/export/expireInventory'

//location

export const Location_Search = '/report/inventory/locationInventory'

export const Export_Location = '/report/export/locationInventory'

//ASN
export const ASN_Search = '/report/inventory/asnDetails'

export const Export_ASN= '/report/export/asnDetails'

//transaction reports
export const Transaction_Report_Filter ='/report/transaction/report'

export const Transaction_Report_Export ='/report/transaction/export'

//fulfillment reports
export const Cost_Info = '/report/fulfillment/fulfillmentCost'

export const Export_Cost_Info ='/report/export/fulfillmentCost'

export const Cost_Details_Info = '/business/order/detail'

export const Cost_Details = '/report/fulfillment/fulfillmentCostDetail'

export const Export_Cost_Details = '/report/export/fulfillmentCostDetail'

//sales reports

export const Summary_Search = 'report/sales/summary'

export const Export_Summary = 'report/export/sales/summary'

export const Individual_Search = '/report/sales/individual'

export const Export_Individual = '/report/export/sales/individual'

export const Warehouse_Search ='/report/sales/warehouse'

export const Export_Warehouse= '/report/export/sales/warehouse'

export const Sales_SKU_Search = '/report/sales/sku'

export const Export_Sale_SKU = '/report/export/sales/sku'

export const Sales_Customer_Search = '/report/sales/customer'

export const Export_Sale_Customer = '/report/export/sales/customer'

export const Sales_Cost_Search = '/report/sales/cost'

export const Export_Sale_Cost = '/report/export/sales/cost'

export const Sales_Batch_Search = '/report/sales/batch'

export const Export_Sale_Batch = '/report/export/sales/batch'


//billing

export const Requisition_Search = '/billing/receive/list'

export const Requisition_Download = '/billing/receive/export'

export const Requisition_Add = '/billing/receive/add'

export const Requisition_Update = '/billing/receive/update'

export const Requisition_Delete = '/billing/receive/delete'

export const Requisition_Information = '/billing/receive/info'

export const Requisition_Add_Check = '/billing/receive/check'

export const Requisition_Warehouse_list = '/billing/receive/warehouse'

export const Requisition_OCP_Generate='/billing/receive/generate'

export const OCP_Generate_Invoice='billing/invoice/ocp/invoicing'

export const Quickbook_Generate_Invoice='/billing/invoice/connectToQuickbooks'

export const Get_Quickbooks_Flag='/billing/invoice/checkQuickbooksStatus'

export const Quickbook_Invoicing='/billing/invoice/quickbooks/invoicing'

export const Send_To_Quickbooks='/billing/invoice/sendToQB'

export const Collect_Payment='/billing/invoice/collect'

export const Generate_Invoice_Pdf='/billing/invoice/generatePdf'

export const Batch_Send_Email='/billing/invoice/sendEmail'

export const Cancel_Invoicing='/billing/invoice/cancel'

export const OwnerCash_Pay_Invoicing='/billing/invoice/ownerCash'

export const Stripe_Pay_Invoicing='/billing/invoice/creditCardDeduction'

export const Send_Invoice_Email='/billing/invoice/send'

export const Edit_Invoice='/billing/invoice/save'

export const Invoice_Search = 'billing/invoice/list'

export const Invoice_Info = 'billing/invoice/info'

export const Invoice_Item_Detail = 'billing/invoice/info'

export const Invoice_Download_Info = 'billing/invoice/print'

export const Invoice_Download_Pdf_File = 'billing/invoice/newPrint'

// export const Invoice_Export_Item_list = 'billing/invoice/invoiceDetailExport'

// export const Other_Fee_Search = 'billing/other/receivable/filter'

export const Other_Fee_List = 'billing/other/receivable/list'

export const Invoice_Export_Item_list = 'billing/invoice/invoiceDetailExport'

export const Other_Fee_Search = 'billing/other/receivable/list'

export const Other_Fee_Info = 'billing/other/receivable/info'

export const Other_Fee_Cancel = 'billing/other/receivable/cancel'

export const Other_Fee_Download = '/billing/batchOpr/other/receivableExport'

export const Storage_Fee_Search = 'billing/storage/list'

export const Storage_Fee_Update = 'billing/storage/update'

export const Storage_Fee_Download = 'billing/storage/export'

export const Fee_No = 'billing/feetype/list'

export const Fee_No_Filter = 'billing/feetype/filter/list'

export const Calculate_Estimate = 'billing/calculate/estimate'

export const Calculate_Detail = 'billing/calculate/calculate'

export const Owner_Cash_List = 'billing/cash/list'

export const Owner_Cash_Info = 'billing/cash/info'

export const Owner_Cash_Save = 'billing/cash/add'

export const Owner_Cash_Modify = 'billing/cash/modify'

export const Owner_Cash_Submit = 'billing/cash/submit'

export const Owner_Cash_Audit = 'billing/cash/audit'

export const Owner_Cash_Delete = 'billing/cash/delete'

export const Owner_Cash_Cancel = 'billing/cash/cancel'

export const Owner_Cash_Export = 'billing/cash/export'
//Admin
export const Non_Canadian_Shipping_Search = '/report/admin/nonCanadaShipFee'

export const Non_Canadian_Shipping_Owner_List = '/report/admin/nonCanadaShipFee/ownerId'

export const Non_Canadian_Shipping_Download = '/report/export/nonCanadaShipFeeExport'

//Inventory Batch
export const Choice_Owner = '/member/owner/choiceOwner'

//product
export const Modify_SKU_Status = '/inventory/sku/modifyStatus'

export const Modify_Kit_Status = '/inventory/kit/modifyStatus'

//customer
export const Filter_Owner = '/member/owner/list'

export const Cargo_Owner_Info = '/member/owner/info'

export const Cargo_Owner_Audit = '/member/owner/auditNewOwner'

export const Cargo_Owner_Discount_Add = '/member/owner/discount/add'

export const Cargo_Owner_Discount_Edit = '/member/owner/discount/modify'

export const Cargo_Owner_Storage_Fee_Term_Edit = '/member/owner/storage/term/modify'

export const Cargo_Owner_Carrier_Edit = '/member/owner/carriers/modify'

export const Discount_Import_Discounts = 'member/batchOpr/discountInfoImport'

export const Cargo_Owner_Discount_List = '/member/owner/discount/list'


export const Cargo_Owner_Address_List = '/member/owner/address/list'
//export inventory , inbound , outbound

export const Export_Inventory_Batch = 'inventory/batchOpr/batchInv'

export const Export_Inventory_Product = 'inventory/batchOpr/productInv'


export const Export_Inbound = 'business/batchOpr/inboundExport'

export const Export_Inbound_Details_By_Filter = 'business/batchOpr/inboundDetailExport'

export const Export_Hung_Up ='/statistic/batchOpr/orderStatsExport'
export const Export_Product_List = 'inventory/batchOpr/skuExport'


export const Export_Wholesale = 'business/batchOpr/wOrderExport'

export const Export_Wholesale_Details_By_Filter = 'business/batchOpr/wOrderDetailExport'

export const Export_Ecommerce = 'business/batchOpr/eOrderExport'

export const Export_Ecommerce_Details_By_Filter = 'business/batchOpr/eOrderDetailExport'

export const Export_Ecommerce_Details = 'business/batchOpr/selectOrderDetailExport'

//dashboard statistic
export const Daily_Fulfilled_Order = '/statistic/order/dailyFulfilledOrder'

export const Daily_Order = '/statistic/order/dailyOrder'

export const Daily_SKU_Info = '/statistic/order/dailySkuNum'

export const Today_Order_Increase = '/statistic/order/num'

export const Today_Fulfillment_Info = '/statistic/order/dailyFulfillmentFee'

export const MonthLy_Order = '/statistic/order/monthlyOrder'

export const MonthLy_Fulfilled_Order = '/statistic/order/monthlyFulfilledOrder'

export const Total_Sku_Inv = '/statistic/order/totalSkuInv'

export const Order_Fulfillment_Metrics ='/statistic/order/multiReq'

export const Commit_Order_List = '/statistic/order/commitOrderList'

export const Notification_Banner = '/statistic/notification/info'

export const Get_Api_Key_For_Auth = '/bg/certified/warehouse/token/info'

export const Authorize = '/bg/certified/warehouse/token/authorize'

//system card
export const Check_Default_Card_Assignment = 'system/stripe/checkCreditCardBinding'

export const Check_Have_Card = 'system/stripe/checkBindingStatus'
export const Default_Card_Client_Secret = 'system/stripe/customerInfo'
export const Attached_Default_Card = 'system/stripe/paymentMethodId'

export const Fetch_Card_List = 'system/stripe/cardList'

export const Check_Default_Card_Assignment_v2 = 'system/stripe/checkCreditCardBinding'

export const Check_Have_Card_v2 = 'system/stripe/checkBindingStatus'
export const Default_Card_Client_Secret_v2 = 'system/stripe/customerInfo'
export const Attached_Default_Card_v2 = 'system/stripe/paymentMethodId'

export const Fetch_Card_List_v2 = 'system/stripe/cardList'

export const Fetch_User_Info = 'system/user/getInfo'


export const Sub_Role = 'system/role/subRole'

export const Sub_Roles_Filter = 'system/user/listSubUser'

export const User_Email_Flag_Filter = 'system/user/listByLoginOwner'

export const Modify_Email_Flag = 'system/user/modifyEmailFlag'

export const Sub_User_Owner_Name = 'member/owner/getOwnerNameBySubUser'

export const Add_Sub_Customer = 'system/user'

export const Reset_Password_Sub_Customer = 'system/user/resetPwd'


export const Menu_List_By_Role = 'system/menu/menuListByRole'


//batch actions
export const Batch_Sync_Status = 'inventory/sku/change/sync'
export const Batch_Sync_trigger = 'inventory/sku/stock/sync'
//integration

export const ECShop_Basic_Info = 'integration/online/basicInfo'
export const Owner_List = 'integration/online/listOwnerInfo'

export const Online_Shop_List = 'integration/online/list'

export const Online_Shop_Info = 'integration/online/listPreview'

export const Online_Shop_Platform_Params = 'integration/online/apiParams'

export const Online_Check_ECShop = 'integration/online/ecShopId'

export const Online_Shop_Add = 'integration/online/onlineShop'

export const Online_Shop_Create = 'integration/online/add'

export const Online_Shop_Edit = 'integration/online/modify'


//system commodity size
export const Commodity_List = 'system/commodity/list'

export const Commodity_Save = 'system/commodity/save'

export const Commodity_Update = 'system/commodity/update'

export const Commodity_Info = 'system/commodity/info'

export const Commodity_Delete = 'system/commodity/delete'

export const Commodity_Export = 'system/commodity/export'

//system size cost
export const Size_Cost_List = 'system/size/cost/list'

export const Size_Cost_Save = 'system/size/cost/save'

export const Size_Cost_Update = 'system/size/cost/update'

export const Size_Cost_Info = 'system/size/cost/info'

export const Size_Cost_Delete = 'system/size/cost/delete'

export const Size_Cost_Export = 'system/size/cost/export'

//user WHMp Config
export const User_WHMp_Config_Info = '/member/userWHMpCfg/info'

export const User_WHMp_Config_Modify = '/member/userWHMpCfg/modify'

export const User_WHMp_Config_Save = '/member/userWHMpCfg/save'

export const User_WHMp_Config_List = '/member/userWHMpCfg/list'


//Storage Fee Filter
export const Storage_Fee_Authority_List = '/system/authority/list'

export const Storage_Fee_Authority_Delete = '/system/authority/delete'

export const Storage_Fee_Authority_Update = '/system/authority/update'

export const Storage_Fee_Authority_Save = '/system/authority/save'

export const Storage_Fee_Authority_Info = '/system/authority/info'

//discount management
export const Discount_Management_List = '/member/discount/fee/list'

export const Discount_Management_Save = '/member/discount/fee/add'

export const Discount_Management_Update = '/member/discount/fee/modify'

export const Discount_Management_Upload = 'member/batchOpr/discountInfoImport'

//warehouse management
export const Warehouse_Management_List = '/system/warehouse/list'

export const Warehouse_Management_Info = '/system/warehouse/info'

export const Warehouse_Management_Save = '/system/warehouse/save'

export const Warehouse_Management_Update = '/system/warehouse/modify'

export const Get_Api_Key = '/oauth/get/appInfo'

export const Generate_key = '/oauth/generate/appInfo'

export const Generate_Access_Token = '/oauth/generate/accessToken'

export const Get_Access_Token = '/oauth/get/accessToken'

//Webhook
export const Webhook_List_Events = '/system/webhook/listEvents'

export const Webhook_List = '/system/webhook/list'

export const Webhook_Add = '/system/webhook/add'

export const Webhook_Update = '/system/webhook/update'

export const Webhook_Delete = '/system/webhook/delete'

//ticket
export const Ticket_Management_List = '/support/ticket/list'

export const Ticket_Save = '/support/ticket/create'

export const Ticket_Assignee_List = '/support/ticket/assignee'

export const Ticket_Management_Export = '/support/ticket/export'

export const  Claim_List= '/support/claim/list'

export const Claim_Add = '/support/claim/create'

export const Claim_Detail = '/support/claim/detail'
